import ProfileCard from "../ui/profile-card";
import BottomMenuItems from "./bottom-menu-items";
import { useContext } from "react";
import DomainContext from "../../contexts/domain-context";

const BottomNav = () => {

    return (
        <div className="grid h-[190px] content-end custom-bg-white-200 lg:px-[17.5px]">
            <BottomMenuItems />
            <ProfileCard toggle />
        </div>
    );
};

export default BottomNav;